module.exports = __webpack_public_path__ + "static/img/wxcode.663a40f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/wxcode.png
// module id = 7AII
// module chunks = 62